import { getBaseMetaTitle } from '@/environments'

const Main = () => import('./Main')

const route = {
  path: '/calendar',
  name: '_calendar',
  meta: {
    title: `Home (DEMO) - ${getBaseMetaTitle}`
  },
  component: Main
}

export default route
